import Modal from "../Modal";
import DeliveryAddressEditForm from "../../forms/deliveryAddress/DeliveryAddressEditForm";
import DealChangeStateForm from "../../forms/deal/DealChangeStateForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DealChangeStateModal({show, handleClose, deal, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("deals.title") + " - " + t("common.confirmation");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <DealChangeStateForm handleClose={handleClose} deal={deal} callback={callback} />
        </Modal>
    );
};